<div class="form-group">
  <label for="prod-m">{{ 'form.user'| translate }}</label>
  <angular2-multiselect [data]="usersList"
    [(ngModel)]="userSelected"
    [settings]="multiselectSettings[EMULTI_SELECT_SETTING.LAZY]"
    (onSelect)="onUserSelect()">
  </angular2-multiselect>
</div>